import { SET_QUALIFICATION_ENROLMENTS } from './actions';

export function setQualificationEnrolments(qualificationEnrolments) {
  return (dispatch) =>
    dispatch({
      type: SET_QUALIFICATION_ENROLMENTS,
      qualificationEnrolments,
    });
}
